import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";

import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Tasks from "components/Tasks/Tasks.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import { bugs, website, server } from "variables/general.js";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";

//new import
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Popper from "@material-ui/core/Popper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Box from "@material-ui/core/Box";
import Slider from "@material-ui/core/Slider";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
import Avatar from "@material-ui/core/Avatar";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import imageavatar1 from "assets/img/faces/vn1.jpg";
import imageavatar2 from "assets/img/faces/vn2.jpg";
import imageavatar3 from "assets/img/faces/vn3.jpg";

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 24,
    borderRadius: 12,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 12,
    backgroundColor: "#52af77", //theme.palette.warning.dark, //"#1a90ff",
  },
}))(LinearProgress);
function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <BorderLinearProgress variant="determinate" {...props} />
        {/* <LinearProgress variant="determinate" {...props} /> */}
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

function createData(name, status, owner, assign, progress, duedate) {
  return { name, status, owner, assign, progress, duedate };
}

const rows = [
  createData(
    "Trục đất: Yêu cầu đất nhuyễn, Rơm rạ vùi lấp, độ lún bùn 25-30cm",
    "Not Yet Started",
    305,
    3.7,
    67,
    "25/June/2020"
  ),
  createData(
    "Ngâm ủ giống: Ngâm 24h, ủ 24h, yêu cầu độ đài mầm 5cm",
    "Done",
    452,
    25.0,
    51,
    "25/June/2020"
  ),
  createData(
    "San phẳng: Yêu cầu mặt ruộng không còn gồ ghề",
    "Denny task",
    262,
    16.0,
    24,
    "25/June/2020"
  ),
  createData(
    "Khơi nước: Yêu cầu mặt đất hết nước và khô ráo",
    "Stuck",
    159,
    6.0,
    24,
    "25/June/2020"
  ),
  createData(
    "Bón lót: Trộn đều phân và rải đều khắp mặt ruộng trước khi cấy",
    "Checking on it",
    356,
    16.0,
    49,
    "25/June/2020"
  ),
  createData(
    "Rải giống: Mật độ 15kg/1000",
    "Not Yet Started",
    408,
    3.2,
    87,
    "25/June/2020"
  ),
  createData(
    "Phun cỏ mầm: Mật độ 0,5l/ha",
    "Not Yet Started",
    237,
    9.0,
    37,
    "25/June/2020"
  ),
  createData(
    "Bơm xả nước: Ngập mặn 0,4cm",
    "Not Yet Started",
    375,
    0.0,
    94,
    "25/June/2020"
  ),
  createData(
    "Thăm ruộng đồng ngày 1,2,3: Tỉ lệ nảy mầm (30 mầm/m2)",
    "Not Yet Started",
    518,
    26.0,
    65,
    "25/June/2020"
  ),
  createData(
    "Thăm ruộng đồng ngày 4,5,6: Độ cao lúa? Số lá? Sâu bệnh?",
    "Not Yet Started",
    392,
    0.2,
    98,
    "25/June/2020"
  ),
  createData(
    "Xử lý bọ trĩ: 2 con/ 1 cây",
    "Not Yet Started",
    318,
    0,
    81,
    "25/June/2020"
  ),
  createData(
    "Xử lý bọ trĩ: 3 con/ 1 cây",
    "Checking on it",
    360,
    19.0,
    9,
    "25/June/2020"
  ),
  createData(
    "Xử lý bọ trĩ: 4 con/ 1 cây",
    "Done",
    437,
    18.0,
    63,
    "25/June/2020"
  ),
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Task Name",
  },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
  { id: "owner", numeric: false, disablePadding: false, label: "Owner" },
  { id: "assign", numeric: false, disablePadding: false, label: "Assign to" },
  { id: "progress", numeric: false, disablePadding: false, label: "Progress" },
  { id: "duedate", numeric: true, disablePadding: false, label: "Due date" },
  { id: "action", numeric: true, disablePadding: false, label: "Actions" },
];

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell className={classes.head} padding="checkbox">
          <Checkbox
            className={classes.head}
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            className={classes.head}
            key={headCell.id}
            align={headCell.numeric ? "right" : "center"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography variant="subtitle2">{headCell.label}</Typography>

              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  const handleaddtask = () => {
    console.log("Add some Task");
    rows.push(
      createData("Add New Task", "Done", 437, 18.0, 63, "25/June/2020")
    );
  };

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Mission Name
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton aria-label="delete">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Add" aria-label="add">
          <Fab size="small" color="secondary" onClick={handleaddtask}>
            <AddIcon />
          </Fab>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  paperpoper: {
    //position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "180px",
    border: "1px solid",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  typo: {
    paddingLeft: "25%",
    marginBottom: "40px",
    position: "relative",
  },
  head: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.common.white,
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  edit: {
    backgroundColor: "transparent",
    color: theme.palette.primary.main,
    boxShadow: "none",
  },
  close: {
    backgroundColor: "transparent",
    color: theme.palette.secondary.main,
    boxShadow: "none",
  },
}));

/// some new style
const useAvatarStyles = makeStyles((theme) => ({
  ava: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  root: {
    width: 100 + theme.spacing(3) * 2,
  },
  avaroot: {
    //width: "56px",
    marginLeft: "160px",
  },
  margin: {
    height: theme.spacing(3),
  },
}));

const PrettoSlider = withStyles({
  root: {
    color: "#52af77",
    height: 8,
  },
  thumb: {
    height: 36,
    width: 36,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -9,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 16px)",
  },
  track: {
    height: 18,
    borderRadius: 8,
  },
  rail: {
    height: 18,
    borderRadius: 8,
  },
})(Slider);

export default function EnhancedTable() {
  const classes = useStyles();
  const classes1 = useAvatarStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [selectrow, setSelectrow] = React.useState(0);

  const handlePoperClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setSelectrow(page * rowsPerPage + parseInt(event.currentTarget.id));
    //console.log(typeof (page * rowsPerPage));
    //console.log("page * rowsPerPage + ", page * rowsPerPage);
    console.log(
      "id cua Poper: ",
      page * rowsPerPage + parseInt(event.currentTarget.id)
    );
    //console.log(typeof event.currentTarget.id);
  };

  const handleSelectStatus = (event) => {
    console.log("index = ", selectrow);
    console.log("rows[index].status ", rows[selectrow].status);
    rows[selectrow].status = event.currentTarget.name;
    console.log("Select Status ", event.currentTarget.name);
  };

  const handleClickAway = () => {
    setAnchorEl(null);
    console.log("Clickaway ");
  };

  // const colorstatus = {white: "Not Yet Started", };
  const handleStatusChange = (event) => {
    //role({ admin: false, manager: false, farmer: false });
    const newStatusButton = { value: "", color: "" };
    //console.log("role la: ", newrole);
    //setRole({ ...newStatusButton, [event.target.value]: event.target.value });
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  //console.log("Row la gì: ", rows);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    console.log("Selected gì? ", newSelected);
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    console.log("newPage là gi?", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>BẢNG DANH SÁCH CÔNG VIÊC</h4>
            <p className={classes.cardCategoryWhite}>Người tạo : Trần Văn A</p>
          </CardHeader>
          <CardBody>
            <div className={classes.root}>
              <Paper className={classes.paper}>
                <EnhancedTableToolbar numSelected={selected.length} />
                <TableContainer>
                  <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    size={dense ? "small" : "medium"}
                    aria-label="enhanced table"
                  >
                    <EnhancedTableHead
                      classes={classes}
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={handleSelectAllClick}
                      onRequestSort={handleRequestSort}
                      rowCount={rows.length}
                    />
                    <TableBody>
                      {stableSort(rows, getComparator(order, orderBy))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.name);
                          const labelId = `enhanced-table-checkbox-${index}`;

                          return (
                            <TableRow
                              hover
                              //onClick={(event) => handleClick(event, row.name)}
                              role="checkbox"
                              aria-checked={isItemSelected}
                              tabIndex={-1}
                              key={row.name}
                              selected={isItemSelected}
                            >
                              <TableCell
                                padding="checkbox"
                                onClick={(event) =>
                                  handleClick(event, row.name)
                                }
                              >
                                <Checkbox
                                  checked={isItemSelected}
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              </TableCell>

                              <TableCell
                                component="th"
                                id={labelId}
                                scope="row"
                                padding="none"
                                nowrap="false"
                                onClick={(event) =>
                                  handleClick(event, row.name)
                                }
                              >
                                {row.name}
                              </TableCell>
                              <TableCell align="center">
                                <div>
                                  <Button
                                    id={index}
                                    //color="white"
                                    fullWidth
                                    color={
                                      row.status == "Not Yet Started"
                                        ? "white"
                                        : row.status == "Done"
                                        ? "info"
                                        : row.status == "Working on it"
                                        ? "success"
                                        : row.status == "Stuck"
                                        ? "warning"
                                        : row.status == "Denny Task"
                                        ? "danger"
                                        : row.status == "Checking on it"
                                        ? "rose"
                                        : row.status == "Done Checking"
                                        ? "primary"
                                        : null
                                    }
                                    onClick={handlePoperClick}
                                  >
                                    {row.status}
                                  </Button>

                                  <Popper
                                    id={id}
                                    open={open}
                                    anchorEl={anchorEl}
                                    placement="bottom"
                                    disablePortal={true}
                                    modifiers={{
                                      flip: {
                                        enabled: true,
                                      },
                                      hide: {
                                        enabled: false,
                                      },
                                      preventOverflow: {
                                        enabled: true,
                                        boundariesElement: "scrollParent",
                                      },
                                      arrow: {
                                        enabled: true,
                                        element: "x-arrow",
                                      },
                                    }}
                                  >
                                    <ClickAwayListener
                                      onClickAway={handleClickAway}
                                    >
                                      <div className={classes.paperpoper}>
                                        <div>
                                          <Button
                                            id={index}
                                            fullWidth
                                            name="Done"
                                            color="info"
                                            onClick={handleSelectStatus}
                                            /* onClick={(event) =>
                                              handleSelectStatus(event
                                              )
                                            } */
                                          >
                                            Done
                                          </Button>
                                          <Button
                                            fullWidth
                                            color="success"
                                            name="Working on it"
                                            onClick={handleSelectStatus}
                                          >
                                            Working on it
                                          </Button>
                                          <Button
                                            fullWidth
                                            color="warning"
                                            name="Stuck"
                                            onClick={handleSelectStatus}
                                          >
                                            Stuck
                                          </Button>
                                          <Button
                                            fullWidth
                                            color="danger"
                                            name="Denny Task"
                                            onClick={handleSelectStatus}
                                          >
                                            Denny Task
                                          </Button>
                                          <Button
                                            fullWidth
                                            color="rose"
                                            name="Checking on it"
                                            onClick={handleSelectStatus}
                                          >
                                            Checking on it
                                          </Button>
                                          <Button
                                            fullWidth
                                            color="primary"
                                            name="Done Checking"
                                            onClick={handleSelectStatus}
                                          >
                                            Done Checking
                                          </Button>
                                        </div>
                                      </div>
                                    </ClickAwayListener>
                                  </Popper>
                                </div>
                              </TableCell>
                              <TableCell padding="default" align="right">
                                <div className={classes1.ava}>
                                  <Avatar alt="Remy Sharp" src={imageavatar1} />
                                </div>
                              </TableCell>
                              <TableCell align="right">
                                <AvatarGroup max={4}>
                                  <Avatar alt="Remy Sharp" src={imageavatar1} />
                                  <Avatar
                                    alt="Travis Howard"
                                    src={imageavatar2}
                                  />
                                  <Avatar
                                    alt="Cindy Baker"
                                    src={imageavatar3}
                                  />
                                  <Avatar
                                    alt="Cindy Baker"
                                    src={imageavatar3}
                                  />
                                  <Avatar
                                    alt="Cindy Baker"
                                    src={imageavatar3}
                                  />
                                </AvatarGroup>
                              </TableCell>
                              <TableCell align="right">
                                <div className={classes1.root}>
                                  {/* <PrettoSlider
                                    valueLabelDisplay="auto"
                                    aria-label="pretto slider"
                                    defaultValue={row.progress}
                                  /> */}
                                  <LinearProgressWithLabel
                                    value={row.progress}
                                  />
                                </div>
                              </TableCell>
                              <TableCell align="right">{row.duedate}</TableCell>
                              <TableCell
                                className={classes.tableActions}
                                padding="default"
                                align="right"
                              >
                                <Tooltip
                                  id="tooltip-top"
                                  title="Edit Task"
                                  placement="top"
                                  classes={{ tooltip: classes.tooltip }}
                                >
                                  <IconButton
                                    aria-label="Edit"
                                    className={classes.tableActionButton}
                                  >
                                    <Edit
                                      className={
                                        classes.tableActionButtonIcon +
                                        " " +
                                        classes.edit
                                      }
                                    />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip
                                  id="tooltip-top-start"
                                  title="Remove"
                                  placement="top"
                                  classes={{ tooltip: classes.tooltip }}
                                >
                                  <IconButton
                                    aria-label="Close"
                                    className={classes.tableActionButton}
                                  >
                                    <Close
                                      className={
                                        classes.tableActionButtonIcon +
                                        " " +
                                        classes.close
                                      }
                                    />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                              {/* <TableCell align="right">{row.fat}</TableCell>
                              <TableCell align="right">{row.carbs}</TableCell>
                              <TableCell align="right">{row.protein}</TableCell> */}
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{ height: (dense ? 33 : 53) * emptyRows }}
                        >
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </Paper>
              <FormControlLabel
                control={
                  <Switch checked={dense} onChange={handleChangeDense} />
                }
                label="Dense padding"
              />
            </div>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>
              Material Dashboard Heading
            </h4>
            <p className={classes.cardCategoryWhite}>
              Created using Roboto Font Family
            </p>
          </CardHeader>
          <CardBody>
            <Tasks
              checkedIndexes={[0, 3]}
              tasksIndexes={[0, 1, 2, 3]}
              tasks={bugs}
            />
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <CustomTabs
          title="Công Việc:"
          headerColor="primary"
          tabs={[
            {
              tabName: "Nông Trường 1",
              tabIcon: BugReport,
              tabContent: (
                <Tasks
                  checkedIndexes={[0, 3]}
                  tasksIndexes={[0, 1, 2, 3]}
                  tasks={bugs}
                />
              ),
            },
            {
              tabName: "Thu Gom Giống",
              tabIcon: Code,
              tabContent: (
                <Tasks
                  checkedIndexes={[0, 2]}
                  tasksIndexes={[0, 1, 2, 3]}
                  tasks={website}
                />
              ),
            },
            {
              tabName: "Kho Chứa",
              tabIcon: Cloud,
              tabContent: (
                <Tasks
                  checkedIndexes={[1]}
                  tasksIndexes={[0, 1, 2]}
                  tasks={server}
                />
              ),
            },
          ]}
        />
      </GridItem>
    </GridContainer>
  );
}
